export default [{
    "name": "2025春夏流行色",
    "colors": [{
        "name": "仙草绿",
        "color": "#d8e8cb",
    }, {
        "name": "冰晶蓝",
        "color": "#cee8ef",
    }, {
        "name": "方解石",
        "color": "#eadde4",
    }, {
        "name": "香槟粉",
        "color": "#f9dccd",
    }, {
        "name": "兰灰紫",
        "color": "#cbc5d2",
    }, {
        "name": "椰子奶油",
        "color": "#f2ece7",
    }, {
        "name": "托斯卡纳",
        "color": "#c09a87",
    }, {
        "name": "冰川灰",
        "color": "#c6cbcb",
    }, {
        "name": "鲨黑",
        "color": "#6d6772",
    }, {
        "name": "碧蓝",
        "color": "#a5ddda",
    }]
}, {
    "name": "蒙德里安",
    "colors": [{
        "name": "火红",
        "color": "#d01c1f",
    }, {
        "name": "金凤花",
        "color": "#fae03c",
    }, {
        "name": "钟乳石",
        "color": "#f7f6f3",
    }, {
        "name": "黑美人",
        "color": "#27272a",
    }, {
        "name": "法国蓝",
        "color": "#0072b5",
    }]
}, {
    "name": "孟菲斯",
    "colors": [{
        "name": "深薄荷",
        "color": "#009e6d",
    }, {
        "name": "樱桃番茄",
        "color": "#eb3c27",
    }, {
        "name": "蓝釉诗",
        "color": "#006ca9",
    }, {
        "name": "黄金融合",
        "color": "#ffb000",
    }, {
        "name": "玫瑰影",
        "color": "#f8c1cc",
    }, {
        "name": "琥珀光",
        "color": "#ffda29",
    }, {
        "name": "地平线蓝",
        "color": "#289dbe",
    }, {
        "name": "节日绽放",
        "color": "#f5d6e6",
    }, {
        "name": "日光碎片",
        "color": "#e95c20",
    }, {
        "name": "黑美人",
        "color": "#27272a",
    }, {
        "name": "夜林私语",
        "color": "#00723b",
    }, {
        "name": "海盐冰",
        "color": "#6ea1d4",
    }, {
        "name": "亮 白",
        "color": "#f4f9ff",
    }, {
        "name": "粉红宇宙",
        "color": "#f07ba5",
    }, {
        "name": "柠 檬",
        "color": "#f3bf09",
    }, {
        "name": "帝国黄",
        "color": "#f7d000",
    }, {
        "name": "柿子红",
        "color": "#f45720",
    }, {
        "name": "法国蓝",
        "color": "#0072b5",
    }, {
        "name": "石英粉",
        "color": "#efa6aa",
    }, {
        "name": "巧 言",
        "color": "#00a776",
    }]
}, {
    "name": "莫兰迪色系",
    "colors": [{
        "name": "蓝色冲浪",
        "color": "#90a8a4",
    }, {
        "name": "莲花",
        "color": "#e2c1c0",
    }, {
        "name": "钟乳石",
        "color": "#f7f6f3",
    }, {
        "name": "澳洲坚果",
        "color": "#e4cfb6",
    }, {
        "name": "豆腐",
        "color": "#e8e4da",
    }, {
        "name": "鸡油菌",
        "color": "#a28776",
    }, {
        "name": "紫罗兰",
        "color": "#c9b4cf",
    }, {
        "name": "白中白",
        "color": "#e7e9e7",
    }, {
        "name": "薰衣草",
        "color": "#afa4ce",
    }, {
        "name": "冰城堡",
        "color": "#daf2f1",
    }, {
        "name": "黄色奶油",
        "color": "#efdc75",
    }, {
        "name": "薄荷晨露",
        "color": "#8dccdd",
    }, {
        "name": "小麦幼苗",
        "color": "#e1e3a9",
    }, {
        "name": "野生酸橙",
        "color": "#c3d363",
    }, {
        "name": "奶油卷",
        "color": "#f1f0e2",
    }, {
        "name": "阿鲁巴蓝",
        "color": "#81d7d3",
    }, {
        "name": "淡黄色",
        "color": "#f2e6b1",
    }]
}, {
    "name": "马卡龙色系",
    "colors": [{
        "name": "甜薰衣草",
        "color": "#9a9bc1",
    }, {
        "name": "盐水滑梯",
        "color": "#cbe9f2",
    }, {
        "name": "麂皮",
        "color": "#f7b26a",
    }, {
        "name": "石 竹",
        "color": "#fc97a5",
    }, {
        "name": "糖珊瑚",
        "color": "#f56c73",
    }, {
        "name": "珊瑚柔",
        "color": "#f37e9b",
    }, {
        "name": "柑橘",
        "color": "#f9ac2f",
    }, {
        "name": "花 束",
        "color": "#f0bdd5",
    }, {
        "name": "照明",
        "color": "#f5df4d",
    }, {
        "name": "草药园",
        "color": "#9cad60",
    }, {
        "name": "浅空邮",
        "color": "#a3bbe0",
    }, {
        "name": "冰青瓷",
        "color": "#4abbd5",
    }, {
        "name": "奶油雏菊",
        "color": "#f4e87a",
    }, {
        "name": "粉红天使",
        "color": "#fdb5c2",
    }, {
        "name": "贝壳粉",
        "color": "#f88180",
    }, {
        "name": "榛子",
        "color": "#ae7250",
    }, {
        "name": "抹茶酪",
        "color": "#adbba1",
    }, {
        "name": "玫瑰烟霉",
        "color": "#d3b4ad",
    }, {
        "name": "五香珊瑚",
        "color": "#d75c5d",
    }, {
        "name": "钢棕",
        "color": "#de8e65",
    }, {
        "name": "流动性",
        "color": "#62b4b8",
    }, {
        "name": "青黛影",
        "color": "#b0d3d1",
    }, {
        "name": "醇黄",
        "color": "#f0dd9d",
    }, {
        "name": "淡丁香",
        "color": "#e1c6cc",
    }, {
        "name": "葡萄酿",
        "color": "#996378",
    }]
}, {
    "name": "中国敦煌",
    "colors": [{
        "name": "熔岩瀑布",
        "color": "#9a2b2e",
    }, {
        "name": "深 钴",
        "color": "#404466",
    }, {
        "name": "赤",
        "color": "#64242e",
    }, {
        "name": "素布青",
        "color": "#bfd1b3",
    }, {
        "name": "紫陶",
        "color": "#634f62",
    }, {
        "name": "谷仓红",
        "color": "#8f423b",
    }, {
        "name": "黑 豆",
        "color": "#2e272a",
    }, {
        "name": "云 雀",
        "color": "#b89b72",
    }, {
        "name": "紫 貂",
        "color": "#6e3f3c",
    }, {
        "name": "橄榄之夜",
        "color": "#535040",
    }, {
        "name": "绿篱",
        "color": "#768a75",
    }, {
        "name": "鼠尾草绿",
        "color": "#b2ac88",
    }, {
        "name": "蛾",
        "color": "#d2cbaf",
    }, {
        "name": "土 坯",
        "color": "#a3623b",
    }, {
        "name": "鳄梨",
        "color": "#676232",
    }, {
        "name": "深橄模",
        "color": "#574d35",
    }, {
        "name": "麻",
        "color": "#c0ad7c",
    }, {
        "name": "秸秆",
        "color": "#e0c992",
    }, {
        "name": "玄岩",
        "color": "#575b61",
    }, {
        "name": "甜葡萄",
        "color": "#4b3b4f",
    }, {
        "name": "鸽子",
        "color": "#b3ada7",
    }, {
        "name": "云霜",
        "color": "#e6ddc5",
    }, {
        "name": "旧书页",
        "color": "#aa9f96",
    }]
}]
